import BaseError, { ErrorProps } from './BaseError';

const SERVER_ERROR_DESCRIPTION = 'Oops! Something went wrong on our end. We are notified. ' +
  'Please try refreshing the page, or come back later.';

export const Error500 = (props: ErrorProps) => (
  <BaseError
    description={SERVER_ERROR_DESCRIPTION}
    title="Internal Server Error"
    {...props} />
);
